import { Text } from '@components/ui/Text';
import { formatRut } from '@utils/rut/formatRut';
import { EMPTY_LABEL } from '@utils/text/commonText';

import { type RutProps } from './types';

const Rut = ({
  fullRut,
  fallbackValue = EMPTY_LABEL,
  ...textProps
}: RutProps) => {
  if (typeof fullRut !== 'string') return fallbackValue;

  const rutFormatted = formatRut(fullRut);

  return <Text {...textProps}>{rutFormatted}</Text>;
};

export { Rut };
